import {Box, Table, TableBody, TableCell, TableRow, Typography} from "@mui/material";
import React from "react";
import {SalaryBatch} from "../../../Component/Model/Dto/Staging/SalaryBatch";
import {MDBox} from "../../../Component/Common/Components/MDBox";
import colors from "../../../assets/theme/base/colors";

interface IProps {
    salaryBatch: SalaryBatch.Breakdown;
}

export const SalaryBatchBreakdownTable: React.FC<IProps> = ({salaryBatch}) => {

    if (!salaryBatch || salaryBatch.totalRecords === 0) {
        return null;
    }

    return (
        <Box mb={2}>
            <Typography variant="h6" mt={2} mb={1}>
                Salary records fetched ({salaryBatch.totalRecords})
            </Typography>
            <Typography variant="body2" color="secondary" mb={1}>
                These are the salary months your payroll supplied. A scorecard can only use months that fall inside
                its own reporting period.
            </Typography>
            <Box sx={{overflowX: "auto"}}>
                <Table size="small" sx={{width: "auto", minWidth: 320}}>
                    <MDBox component="thead">
                        <TableRow>
                            <TableCell>Month</TableCell>
                            {salaryBatch.salaryTypes.map((salaryType) => (
                                <TableCell key={salaryType} align="right">{salaryType}</TableCell>
                            ))}
                            <TableCell align="right">Total</TableCell>
                        </TableRow>
                    </MDBox>
                    <TableBody>
                        {salaryBatch.months.map((month) => (
                            <TableRow key={month.month}>
                                <TableCell>{month.month}</TableCell>
                                {month.countsBySalaryType.map((count, index) => (
                                    <TableCell key={salaryBatch.salaryTypes[index]} align="right">{count}</TableCell>
                                ))}
                                <TableCell align="right">{month.total}</TableCell>
                            </TableRow>
                        ))}
                        <TableRow>
                            <TableCell sx={{color: colors.dark.main, fontWeight: "bold"}}>All months</TableCell>
                            {salaryBatch.totalsBySalaryType.map((total, index) => (
                                <TableCell key={salaryBatch.salaryTypes[index]} align="right" sx={{color: colors.dark.main, fontWeight: "bold"}}>
                                    {total}
                                </TableCell>
                            ))}
                            <TableCell align="right" sx={{color: colors.dark.main, fontWeight: "bold"}}>
                                {salaryBatch.totalRecords}
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Box>
        </Box>
    );
};
